import React from 'react';
import { useTranslation } from 'react-i18next';
import { BuyNow } from 'autogen/translation-keys/trans-website-shared-buttons';
import { ButtonWithSpinner } from 'components/Button';
import ButtonWithAnimatedStatuses from 'components/Button/ButtonWithAnimatedStatuses';
import type { ProductActionProps } from '../../shared/types';
import { useAddToBasket } from './action';

export function AddProductButton({ params, trackingInfo, children, ...restProps }: ProductActionProps['BuyNow']) {
    const { t } = useTranslation();

    const clickToAddBasket = useAddToBasket(params, trackingInfo);

    return (
        <ButtonWithSpinner onClick={clickToAddBasket} type="button" {...restProps}>
            {children || t(BuyNow)}
        </ButtonWithSpinner>
    );
}

function AddProductButtonCompact({ params, trackingInfo, ...restProps }: ProductActionProps['BuyNow']) {
    const { t } = useTranslation();

    const clickToAddBasket = useAddToBasket(params, trackingInfo);

    return (
        <ButtonWithAnimatedStatuses onClick={clickToAddBasket} type="button" aria-label={t(BuyNow)} {...restProps} />
    );
}
//
export default Object.assign(AddProductButton, {
    Compact: AddProductButtonCompact
});
